import type { ReactNode } from "react";
import { Children, cloneElement, isValidElement, useId } from "react";

export function Field({
  label,
  required,
  optional,
  hint,
  error,
  children,
  helpRight,
}: {
  label: string;
  required?: boolean;
  optional?: boolean;
  hint?: ReactNode;
  error?: ReactNode;
  helpRight?: ReactNode;
  children: ReactNode;
}) {
  // Generate a unique ID for label association
  const fieldId = useId();

  // Clone the child element and inject the id prop for label association
  const childWithId = Children.map(children, (child) => {
    if (isValidElement(child)) {
      // Only add id if the child doesn't already have one
      return cloneElement(child as React.ReactElement<{ id?: string }>, {
        id: (child.props as { id?: string }).id || fieldId,
      });
    }
    return child;
  });

  return (
    <div className="field">
      <div className="label">
        <label htmlFor={fieldId}>
          {label}
          {required && <span className="req">*</span>}
          {optional && <span className="opt"> (optional)</span>}
        </label>
        {helpRight}
      </div>
      {childWithId}
      {error ? (
        <div className="helptext error">{error}</div>
      ) : hint ? (
        <div className="helptext">{hint}</div>
      ) : null}
    </div>
  );
}
